"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ToolbarSeparator: true
};
exports.default = exports.ToolbarSeparator = void 0;
var _react = _interopRequireDefault(require("react"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _ToolbarSeparator = require("./_ToolbarSeparator.types");
Object.keys(_ToolbarSeparator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ToolbarSeparator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToolbarSeparator[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-toolbar';
const ToolbarSeparator = exports.ToolbarSeparator = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(ToolbarSeparator, _props)) : _props;
  const {
      overflowOnly,
      horizontal
    } = props,
    rest = __rest(props, ["overflowOnly", "horizontal"]);
  const classnames = _bind.default.bind(_Toolbar.default);
  return /*#__PURE__*/_react.default.createElement("span", Object.assign({
    ref: ref,
    role: "separator"
  }, rest, {
    className: classnames(`${CSS_BLOCK}__separator`, {
      [`${CSS_BLOCK}__separator--horizontal`]: horizontal,
      [`${CSS_BLOCK}__separator--overflow-only`]: overflowOnly
    })
  }));
});
ToolbarSeparator.displayName = 'ToolbarSeparator';
var _default = exports.default = ToolbarSeparator;